import React, { useState, useEffect } from "react";
import { getAsesorById } from "../../endpoints.js";
import {
  Container,
  Header,
  Row,
  Data,
  ObservationsText
} from "./styles.js"

const HistoricoComunicacion = ({ observations, convertirFecha }) => {
  const [asesorNames, setAsesorNames] = useState({});

  useEffect(() => {
    if (observations && observations.length > 0) {
      observations.forEach((data) => {
        if (data.userId) {
          getAsesorById(data.userId).then((res) => {
            if (res.status === 200) {
              setAsesorNames((prevAsesorNames) => ({
                ...prevAsesorNames,
                [data.id]: res.data.name +  " " + res.data.lastname,
              }));
            } else {
              setAsesorNames((prevAsesorNames) => ({
                ...prevAsesorNames,
                [data.id]: "-",
              }));
            }
          });
        }
      });
    }
  }, [observations]);

  return (
    <Container>
      <Row>
        <Header><b>Fecha</b></Header>
        <Header><b>Observación</b></Header>
        <Header><b>Asesor</b></Header>
      </Row>
      {observations && observations.length > 0
        ? observations.map((data) => (
          <Row key={data.id} style={{
            borderBottom: '1px solid #c8c7c7',
            paddingBottom: '5px',
            margin: '0px'
          }}>
            <Data>{convertirFecha(data.updatedAt)}</Data>
            <ObservationsText>{data.observacion}</ObservationsText>
            <Data>{asesorNames[data.id]}</Data>
          </Row>
        ))
        : <Row style={{
          borderBottom: '1px solid #c8c7c7',
          paddingBottom: '5px',
          margin: '0px'
        }}>
          <Data>-</Data>
          <ObservationsText>-</ObservationsText>
        </Row>
      }
    </Container>
  );
};

export default HistoricoComunicacion;
